<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer">
    <vs-button class="btn-drop" type="filled" icon="more_vert" icon-after
      >Actions</vs-button
    >
    <vs-dropdown-menu>
      <vs-dropdown-group vs-label="Mark guest list items as">
        <vs-dropdown-item
          v-for="(action, index) in actions"
          :key="'booking-action-' + index"
          @click="handleActionSelected(action)"
        >
          <div class="flex items-center w-48 p-2">
            <feather-icon :icon="action.icon" v-if="action.icon" />
            <span class="ml-2">{{ action.name }}</span>
          </div>
        </vs-dropdown-item>
      </vs-dropdown-group>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import { GUEST_LIST_ITEM_ARRIVAL_STATE } from "@/store/modules/marcom/data-model/guest-list-items/guest-list-item.js";

export default {
  components: {},
  props: {
  },
  data() {
    return {
      actions: this.buildActions()
    }
  },
  mounted() {
  },
  methods: {
    handleActionSelected(arrivalState) {
      this.$emit('guest-list-item-action-selected', arrivalState);
    },
    buildActions() {
      let arrivalStates = GUEST_LIST_ITEM_ARRIVAL_STATE.getAll();
      let actions = arrivalStates.map(a => {
        return {
          type: 'GUEST_LIST_ITEM_ARRIVAL_STATE',
          value: a,
          name: GUEST_LIST_ITEM_ARRIVAL_STATE.nameof(a),
          icon: GUEST_LIST_ITEM_ARRIVAL_STATE.iconof(a),
        }
      });

      return actions;
    }
  }
};
</script>

<style lang="scss" scoped>
.con-vs-dropdown--menu {
  z-index: 54000;
}
</style>
